module.exports = __webpack_public_path__ + "img/close.661f5767.png";